export default {
  moneySymbol: '¥',
  form: {
    lightFilter: {
      more: 'もっと',
      clear: '明確',
      confirm: '確認',
      itemUnit: '項目'
    }
  },
  tableForm: {
    search: '検索',
    reset: 'リセット',
    submit: '提交',
    collapsed: '展開',
    expand: '収納',
    inputPlaceholder: '入力してください',
    selectPlaceholder: '選択してください'
  },
  alert: {
    clear: 'クリア',
    selected: '選択した',
    item: '項目'
  },
  pagination: {
    total: {
      range: '記事',
      total: '/合計',
      item: ' '
    }
  },
  tableToolBar: {
    leftPin: '左に固定',
    rightPin: '右に固定',
    noPin: 'キャンセル',
    leftFixedTitle: '左に固定された項目',
    rightFixedTitle: '右に固定された項目',
    noFixedTitle: '固定されてない項目',
    reset: 'リセット',
    columnDisplay: '表示列',
    columnSetting: '列表示設定',
    fullScreen: 'フルスクリーン',
    exitFullScreen: '終了',
    reload: '更新',
    density: '行高',
    densityDefault: 'デフォルト',
    densityLarger: '默认',
    densityMiddle: '中',
    densitySmall: '小'
  },
  stepsForm: {
    next: '次のステップ',
    prev: '前',
    submit: '送信'
  },
  loginForm: {
    submitText: 'ログイン'
  },
  editableTable: {
    action: {
      save: '救う',
      cancel: 'キャンセル',
      delete: '削除',
      add: '1行のデータを追加します'
    }
  },
  switch: {
    open: 'オープン',
    close: '近い'
  }
};